@if (formGroup && !busy) {
    <form class="container" [formGroup]="formGroup" (ngSubmit)="save()">
        <div class="row top-row">
            <div class="col-md-5 header mb-xl-4 mb-lg-4 mb-md-4">
                <div class="header-title">
                    <h3 class="main-title">
                        {{ 'businesspartner.general.new-title' | translate }}
                    </h3>
                    <p class="description">
                        {{ 'shared.miscellaneous.user-change-values' | translate }}
                    </p>
                </div>
            </div>
            <div class="col-md-7 my-2 mb-sm-3">
                <div class="d-flex flex-wrap justify-content-start justify-content-sm-end gap-10">
                    @if (!closePopup && 'businesspartner.readAll' | hasPermission: permissions) {
                        <ceres-button icon="forum" routerLink="/businesspartner">
                            {{ 'businesspartner.general.title' | translate }}
                        </ceres-button>
                    }
                    <ceres-button icon="check-mark" type="submit" [disabled]="false">
                        {{ 'shared.buttons.save' | translate }}
                    </ceres-button>
                    @if (closePopup) {
                        <ceres-button [style]="'red'" icon="close" (click)="close()">
                            {{ 'shared.buttons.cancel' | translate }}
                        </ceres-button>
                    }
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-6 mb-4 form-container">
                <div class="options-form padding">
                    <div class="row">
                        @if (!showEmail) {
                            <div class="col-sm-6">
                                <ceres-user-picker
                                    (selected)="chooseEmployee($event)"
                                    [extern]="true"
                                    [fullUser]="true"
                                    [appUser]="false"
                                    [multiple]="false"
                                    [placeholder]="'shared.buttons.scd-add-person' | translate"
                                    [value]="businessPartner['user']"
                                    [condition]="pickerCondition('businessPartner')"
                                >
                                    <!--[required]="formGroup.value.gpType !== 'External'"-->
                                </ceres-user-picker>
                            </div>
                        }
                        @if (showEmail) {
                            <div class="col-sm-6">
                                <mat-form-field class="mat-custom w-100" appearance="fill">
                                    <mat-label>{{ 'shared.properties.e-mail' | translate }}</mat-label>
                                    <input formControlName="eMail" matInput (change)="checkBPExists()" />
                                </mat-form-field>
                            </div>
                        }
                        <div class="col-sm-6">
                            <mat-form-field class="mat-custom w-100" appearance="fill">
                                <mat-label>GID</mat-label>
                                <input formControlName="gid" matInput />
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-6">
                            <mat-form-field class="mat-custom w-100" appearance="fill">
                                <mat-label>{{ 'businesspartner.properties.type' | translate }}</mat-label>
                                <mat-select formControlName="gpType" required (selectionChange)="chooseGPType()">
                                    @for (item of gpTypeOptions | translateOrder; track item) {
                                        <mat-option [value]="item">
                                            {{
                                                isIntern(item)
                                                    ? tenantName + ' ' + (item.translationKey | translate)
                                                    : (item.translationKey | translate)
                                            }}
                                        </mat-option>
                                    }
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                    <div formArrayName="companyNames" class="row">
                        @for (company of companyNamesControl; track company; let i = $index) {
                            <ng-container [formGroupName]="i">
                                <div class="col-12">
                                    <div class="company-names">
                                        <mat-form-field class="mat-custom w-100" appearance="fill">
                                            <mat-label
                                                >{{ 'businesspartner.properties.company-name' | translate }}
                                                {{ i + 1 }}</mat-label
                                            >
                                            <input formControlName="name" matInput />
                                        </mat-form-field>
                                        @if (checkCompany(i, company.value.name)) {
                                            <mat-icon
                                                (click)="addNewRow()"
                                                [style.right.px]="i !== 0 ? 36 : 0"
                                                class="mat-custom fw-bold"
                                                matSuffix
                                                >add</mat-icon
                                            >
                                        }
                                        @if (i !== 0) {
                                            <mat-icon (click)="deleteCompany(i)" class="mat-custom" matSuffix
                                                >delete</mat-icon
                                            >
                                        }
                                    </div>
                                </div>
                            </ng-container>
                        }
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <mat-form-field class="mat-custom w-100" appearance="fill">
                                <mat-label>{{ 'shared.properties.department' | translate }}</mat-label>
                                <input formControlName="department" matInput />
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        @if (businessPartnerConfig.validateLabel('business-partner.salutation')) {
                            <div class="col-sm-6">
                                <mat-form-field class="mat-custom w-100" appearance="fill">
                                    <mat-label>{{
                                        'businesspartner.properties.salutation.title' | translate
                                    }}</mat-label>
                                    <mat-select formControlName="salutation">
                                        <mat-option value="Mr.">{{
                                            'businesspartner.properties.salutation.mr' | translate
                                        }}</mat-option>
                                        <mat-option value="Ms.">{{
                                            'businesspartner.properties.salutation.ms' | translate
                                        }}</mat-option>
                                        <mat-option value="None">{{
                                            'businesspartner.properties.salutation.none' | translate
                                        }}</mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                        }
                        @if (businessPartnerConfig.validateLabel('business-partner.title')) {
                            <div class="col-sm-6">
                                <mat-form-field class="mat-custom w-100" appearance="fill">
                                    <mat-label>{{ 'shared.miscellaneous.title' | translate }}</mat-label>
                                    <mat-select formControlName="title">
                                        <mat-option value=""></mat-option>
                                        <mat-option value="Dr.">{{
                                            'businesspartner.properties.title-types.dr' | translate
                                        }}</mat-option>
                                        <mat-option value="Prof.">{{
                                            'businesspartner.properties.title-types.prof' | translate
                                        }}</mat-option>
                                        <mat-option value="Prof. Dr."
                                            >{{ 'businesspartner.properties.title-types.prof-dr' | translate }}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                        }
                    </div>
                    <div class="row">
                        <div class="col-sm-6">
                            <mat-form-field class="mat-custom w-100" appearance="fill">
                                <mat-label>{{ 'shared.miscellaneous.firstname' | translate }}</mat-label>
                                <input formControlName="firstName" matInput required />
                            </mat-form-field>
                        </div>
                        <div class="col-sm-6">
                            <mat-form-field class="mat-custom w-100" appearance="fill">
                                <mat-label>{{ 'shared.miscellaneous.lastname' | translate }}</mat-label>
                                <input formControlName="surName" matInput required />
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        @if (businessPartnerConfig.validateLabel('business-partner.subject-area')) {
                            <div class="col-sm-6">
                                <mat-form-field class="mat-custom w-100" appearance="fill">
                                    <mat-label>{{ 'businesspartner.properties.subject-area' | translate }}</mat-label>
                                    <mat-select formControlName="subjectArea" [required]="!isExternalPartner">
                                        <mat-option>
                                            <ngx-mat-select-search
                                                [placeholderLabel]="'shared.miscellaneous.search-dots' | translate"
                                                [formControl]="subjectAreaFilterCtrl"
                                                ><span ngxMatSelectNoEntriesFound>
                                                    {{ 'shared.miscellaneous.no-entries-found' | translate }}
                                                </span></ngx-mat-select-search
                                            >
                                        </mat-option>
                                        @for (item of subjectAreasOptions | async | translateOrder; track item) {
                                            <mat-option [value]="item">{{
                                                item.translationKey | translate
                                            }}</mat-option>
                                        }
                                    </mat-select>
                                </mat-form-field>
                            </div>
                        }
                        @if (businessPartnerConfig.validateLabel('business-partner.function')) {
                            <div class="col-sm-6">
                                <mat-form-field class="mat-custom w-100" appearance="fill">
                                    <mat-label>{{ 'businesspartner.properties.function' | translate }}</mat-label>
                                    <mat-select formControlName="function" [required]="!isExternalPartner">
                                        @for (item of functions | translateOrder; track item) {
                                            <mat-option [value]="item">{{
                                                item.translationKey | translate
                                            }}</mat-option>
                                        }
                                    </mat-select>
                                </mat-form-field>
                            </div>
                        }
                    </div>
                    <div class="row">
                        @if (businessPartnerConfig.validateLabel('business-partner.budget-responsibility')) {
                            <div class="col-sm-6">
                                <mat-form-field class="mat-custom w-100" appearance="fill">
                                    <mat-label>{{
                                        'businesspartner.properties.budget-responsibility' | translate
                                    }}</mat-label>
                                    <mat-select formControlName="budgetResponsibility" required>
                                        @for (item of budgetOptions | translateOrder; track item) {
                                            <mat-option [value]="item">{{
                                                item.translationKey | translate
                                            }}</mat-option>
                                        }
                                    </mat-select>
                                </mat-form-field>
                            </div>
                        }
                    </div>
                </div>
                <div class="options-form options-form--header">
                    <div class="row">
                        <div class="col-12">
                            <p>
                                {{ 'businesspartner.properties.customer-contacts' | translate }}
                            </p>
                        </div>
                    </div>
                </div>
                <div class="options-form">
                    <div class="row">
                        <div class="col-12">
                            <ceres-user-picker
                                (selected)="changeMainCustomerContact($event)"
                                [appUser]="true"
                                [condition]="pickerCondition('mainCustomerContact')"
                                [dpt]="true"
                                [extern]="false"
                                [required]="true"
                                [value]="businessPartner.mainCustomerContact"
                                placeholder="{{ 'businesspartner.properties.customer-contact' | translate }}"
                                [noCheck]="true"
                            >
                            </ceres-user-picker>
                        </div>
                        <div class="col-12">
                            <ceres-user-picker
                                (selected)="changeCustomerContact($event)"
                                [appUser]="true"
                                [dpt]="true"
                                [extern]="false"
                                [multiple]="true"
                                [value]="businessPartner.customerContact"
                                [noCheck]="true"
                                buttonText="{{ 'businesspartner.properties.new-customer-contact' | translate }}"
                            ></ceres-user-picker>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <mat-form-field class="mat-custom w-100" appearance="fill">
                                <mat-label>{{ 'businesspartner.properties.personal-relation' | translate }}</mat-label>
                                <textarea formControlName="personalRelation" matInput></textarea>
                            </mat-form-field>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 form-container margin">
                <div class="options-form options-form--header">
                    <div class="row">
                        <div class="col-12">
                            <p>
                                {{ 'businesspartner.properties.contact-information' | translate }}
                            </p>
                        </div>
                    </div>
                </div>
                <div class="options-form">
                    <div class="row">
                        @if (businessPartnerConfig.validateLabel('business-partner.phone')) {
                            <div class="col-sm-6">
                                <mat-form-field class="mat-custom w-100" appearance="fill">
                                    <mat-label>{{ 'businesspartner.properties.phone' | translate }}</mat-label>
                                    <input type="tel" formControlName="phone" matInput />
                                </mat-form-field>
                            </div>
                        }
                        @if (businessPartnerConfig.validateLabel('business-partner.fax')) {
                            <div class="col-sm-6">
                                <mat-form-field class="mat-custom w-100" appearance="fill">
                                    <mat-label>{{ 'businesspartner.properties.fax' | translate }}</mat-label>
                                    <input type="tel" formControlName="fax" matInput />
                                </mat-form-field>
                            </div>
                        }
                    </div>
                    <div class="row">
                        <div class="col-sm-6">
                            <mat-form-field class="mat-custom w-100" appearance="fill">
                                <mat-label>{{ 'businesspartner.properties.mobile' | translate }}</mat-label>
                                <input type="tel" formControlName="mobile" matInput />
                            </mat-form-field>
                        </div>
                        <div class="col-sm-6">
                            <mat-form-field class="mat-custom w-100" appearance="fill">
                                <mat-label>{{ 'shared.properties.location' | translate }}</mat-label>
                                <input formControlName="location" matInput />
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        @if (!showEmail) {
                            <div class="col-12">
                                <mat-form-field class="mat-custom w-100" appearance="fill">
                                    <mat-label>{{ 'shared.properties.e-mail' | translate }}</mat-label>
                                    <input formControlName="eMail" matInput required />
                                </mat-form-field>
                            </div>
                        }
                    </div>
                </div>
                <div class="options-form options-form--header">
                    <div class="row">
                        <div class="col-12">
                            <p>
                                {{ 'businesspartner.properties.address-information' | translate }}
                            </p>
                        </div>
                    </div>
                </div>
                <div class="options-form">
                    <div class="row">
                        <div class="col-sm-6">
                            <mat-form-field class="mat-custom w-100" appearance="fill">
                                <mat-label>{{ 'businesspartner.properties.street' | translate }}</mat-label>
                                <input formControlName="street" matInput />
                            </mat-form-field>
                        </div>
                        @if (businessPartnerConfig.validateLabel('business-partner.po-box')) {
                            <div class="col-sm-6">
                                <mat-form-field class="mat-custom w-100" appearance="fill">
                                    <mat-label>{{ 'businesspartner.properties.postal-box' | translate }}</mat-label>
                                    <input formControlName="poBox" matInput />
                                </mat-form-field>
                            </div>
                        }
                        <div class="col-sm-6">
                            <mat-form-field class="mat-custom w-100" appearance="fill">
                                <mat-label>{{ 'businesspartner.properties.city' | translate }}</mat-label>
                                <input matInput formControlName="city" />
                            </mat-form-field>
                        </div>
                        <div class="col-sm-6">
                            <mat-form-field class="mat-custom w-100" appearance="fill">
                                <mat-label>{{ 'businesspartner.properties.zip' | translate }}</mat-label>
                                <input formControlName="zip" matInput maxlength="5" />
                            </mat-form-field>
                        </div>
                        <div class="col-sm-6">
                            <mat-form-field class="mat-custom w-100" appearance="fill">
                                <mat-label>{{ 'businesspartner.properties.cc' | translate }}</mat-label>
                                <input matInput formControlName="countryCode" />
                            </mat-form-field>
                        </div>
                        @if (businessPartnerConfig.validateLabel('business-partner.country')) {
                            <div class="col-sm-6">
                                <mat-form-field class="mat-custom w-100" appearance="fill">
                                    <mat-label>{{ 'shared.properties.country' | translate }}</mat-label>
                                    <input matInput formControlName="country" />
                                </mat-form-field>
                            </div>
                        }
                        @if (businessPartnerConfig.validateLabel('business-partner.language')) {
                            <div class="col-12">
                                <mat-form-field class="mat-custom w-100" appearance="fill">
                                    <mat-label>{{ 'shared.properties.language' | translate }}</mat-label>
                                    <mat-select formControlName="language" [required]="!isExternalPartner">
                                        @for (item of languageOptions | translateOrder; track item) {
                                            <mat-option [value]="item">
                                                {{ item.translationKey | translate }}
                                            </mat-option>
                                        }
                                    </mat-select>
                                </mat-form-field>
                            </div>
                        }
                    </div>
                </div>
                <div class="options-form padding">
                    @if (businessPartnerConfig.validateLabel('business-partner.status')) {
                        <div class="row">
                            <div class="col-12">
                                <mat-form-field class="mat-custom w-100" appearance="fill">
                                    <mat-label>{{ 'shared.properties.status' | translate }}</mat-label>
                                    <mat-select formControlName="status" required>
                                        @for (item of statusOptions | translateOrder; track item) {
                                            <mat-option [value]="item">{{
                                                item.translationKey | translate
                                            }}</mat-option>
                                        }
                                    </mat-select>
                                </mat-form-field>
                            </div>
                        </div>
                    }
                    <div class="row">
                        @if (businessPartnerConfig.validateLabel('business-partner.newsletter-candidate')) {
                            <div class="col-sm-6 space-checkbox">
                                <mat-checkbox
                                    [disableControl]="
                                        businessPartner.advertisingBarrier || businessPartner.newsletterBarrier
                                    "
                                    formControlName="newsletterCandidate"
                                    labelPosition="after"
                                    >{{ 'businesspartner.properties.newsletter-candidate' | translate }}
                                </mat-checkbox>
                            </div>
                        }
                        @if (businessPartnerConfig.validateLabel('business-partner.ad-blocking')) {
                            <div class="col-sm-6 space-checkbox">
                                <mat-checkbox
                                    [disableControl]="
                                        businessPartner.newsletterCandidate || businessPartner.newsletterBarrier
                                    "
                                    formControlName="advertisingBarrier"
                                    labelPosition="after"
                                    >{{ 'businesspartner.properties.total-ad-blocking' | translate }}
                                </mat-checkbox>
                            </div>
                        }
                    </div>
                    <div class="row">
                        @if (businessPartnerConfig.validateLabel('business-partner.newsletter-blocking')) {
                            <div class="col-sm-6 space-checkbox">
                                <mat-checkbox
                                    [disableControl]="
                                        businessPartner.newsletterCandidate || businessPartner.advertisingBarrier
                                    "
                                    formControlName="newsletterBarrier"
                                    labelPosition="after"
                                    >{{ 'businesspartner.properties.newsletter-blocking' | translate }}
                                </mat-checkbox>
                            </div>
                        }
                        @if (businessPartnerConfig.validateLabel('business-partner.checked-marked-for-deletion')) {
                            <div class="col-sm-6 space-checkbox">
                                <mat-checkbox
                                    [disableControl]="businessPartner.inFocus"
                                    formControlName="deleteBookmarked"
                                    labelPosition="after"
                                    >{{ 'businesspartner.properties.marked-for-deletion' | translate }}</mat-checkbox
                                >
                            </div>
                        }
                    </div>
                    <div class="row">
                        @if (businessPartnerConfig.validateLabel('business-partner.focus')) {
                            <div class="col-sm-6 space-checkbox">
                                <mat-checkbox
                                    [disableControl]="businessPartner.deleteBookmarked"
                                    formControlName="inFocus"
                                    labelPosition="after"
                                    >{{ 'businesspartner.properties.checked-in-focus' | translate }}</mat-checkbox
                                >
                            </div>
                        }
                        @if (businessPartnerConfig.validateLabel('business-partner.christmas-card')) {
                            <div class="col-sm-6 space-checkbox">
                                <mat-checkbox formControlName="christmasCard" labelPosition="after">{{
                                    'businesspartner.properties.christmas-card' | translate
                                }}</mat-checkbox>
                            </div>
                        }
                    </div>
                </div>
            </div>
        </div>
    </form>
}
@if (!formGroup || busy) {
    <ceres-loading></ceres-loading>
}
